// LICENSE : MIT
"use strict";
var McFly = require("mcfly");
module.exports = new McFly();



/*****************
 ** WEBPACK FOOTER
 ** ./lib/flux-index.js
 ** module id = 2
 ** module chunks = 0
 **/